<template>
<!-- 基础信息 -->
  <div class="txzl-wrap">
    <p>*您的信息仅展示给银行或持牌平台，未经您授权我们不会泄露您的信息*</p>
    <div class="txzl-wrap-title">
      <span>基本信息</span>
      <span @click="$router.go(-1)" v-if="loanNumber!== 1">上一步</span>
    </div>
    <van-form @submit="onSubmit">
      <van-cell-group :border="false">
        <van-field label="真实姓名" v-if="infoData.result.realname"  v-model="form.realname" :border="false"  placeholder="请输入真实姓名" />
        <van-field label="身份证号" v-if="infoData.result.idcard" maxlength="18"  v-model="form.idcard" :border="false"  placeholder="请输入身份证号" />
        <van-field
          v-if="infoData.result.city_name"
          :border="false"
          v-model="form.city_name"
          is-link
          readonly
          label="工作城市"
          placeholder="请选择工作城市"
          @click="showCity = true"
        />
        <van-field v-if="infoData.result.income_name" :border="false" name="stepper" label="月收入">
          <template #input>
              <van-stepper  theme="round"  input-width="50px" step="1000" min="2000" max="30000" v-model="form.income_name" integer />
              <span class="stepper-span">(2000元-3万元)</span> 
          </template>
        </van-field>
        <van-field :border="false" v-if="infoData.result.incomefrom_name"  name="radio"  v-model="form.incomefrom_name" label="收入形式">
          <template #input>
            <div class="newradio">
              <div @click="checksrxsRadio('银行代发')" :class="[form.incomefrom_name === '银行代发' ? 'mycheckRadio': 'myradio']">
                <span>银行代发</span>
              </div>
              <div  @click="checksrxsRadio('现金发放')" :class="[form.incomefrom_name === '现金发放' ? 'mycheckRadio': 'myradio']">
                <span>现金发放</span>
              </div>
            </div>
          </template>
        </van-field>
        <van-field name="radio" :border="false" v-if="infoData.result.creditrecord_name"  v-model="form.creditrecord_name" label="信用记录">
          <template #input>
            <div class="newradio">
              <div @click="checkxyjlRadio('1年内有逾期')" :class="[form.creditrecord_name === '1年内有逾期' ? 'mycheckRadio': 'myradio']">
                <span>1年内有逾期</span>
              </div>
              <div  @click="checkxyjlRadio('1年内无逾期')" :class="[form.creditrecord_name === '1年内无逾期' ? 'mycheckRadio': 'myradio']">
                <span>1年内无逾期</span>
              </div>
            </div>
          </template>
        </van-field>
        <van-field
          v-if="infoData.result.welidai_name"
          v-model="form.welidai_name"
          center
          label="微粒贷"
          placeholder="请输入"
          :border="false"
          type="digit"
          @keyup="keyupWelidai"
        >
          <template #button>
            <div @click="checkWelidai" :class="[showWlid ? 'mycheckRadio' : 'myradio']"><span>无微粒贷</span></div>
          </template>
        </van-field>
      </van-cell-group>  
      <button class="btn-fixed"  type="submit">
        <div class="loanbtn">
          <p>下一步({{loanNumber}}/{{infoData.param_total}})</p>
        </div>
      </button>
    </van-form>
    
    <van-popup v-model="showCity" round position="bottom">
      <van-cascader
        readonly
        v-model="cascaderValue"
        title="请选择所在地区"
        :options="carareaOption"
        @close="showCity = false"
        @finish="onFinish"
        @change="onChange"
        active-color="#0294FF"
      />
    </van-popup>
  </div>
</template>
<script>
import { CellGroup, Cell, Radio, RadioGroup, Button, Field, Cascader, Popup, Stepper, Toast, Form } from 'vant'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'Baseinfo',
  data() {
    const infoData = JSON.parse(window.localStorage.getItem('infoData'))
    return {
      form: {
        realname: '',
        idcard: '',
        city_name: '',
        income_name: '2000',
        incomefrom_name: '',
        creditrecord_name: '',
        welidai_name: '',
        provcity: '',
      },
      loanBtnWidth: 0,
      showCity: false,
      cascaderValue: '',
      loanNumber: Number(this.$route.query.loanNumber),
      carareaOption: [],
      channel_lable: window.localStorage.getItem('channel'),
      showWlid: false,
      idcarExp: /^(\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/,
      infoData
    }
  },
  created() {
    const formData = window.localStorage.getItem('baseInfoData')
    this.loanBtnWidth = ((this.loanNumber-1)/Number(this.infoData.param_total))*100
    if(!!formData) {
      this.form = Object.assign({}, this.form, JSON.parse(formData)) 
      if(this.form.welidai_name === '') {
        this.showWlid = true
      }
      // console.log(formData.realname)
    }
    this.fetchCommon({
      request: 'webapi/areainfo',
      path: 'webapi/areainfo',
      onSuccess: (res) => {
        this.carareaOption = res.data.map((a, index)=>{
          a.text = a.prov_name
          a.index = index
          a.value = a.prov_id
          a.children = []
          return a
        })
      },
      onFail: (err) => {
        this.$toast(err.msg)
      }
    })
  },
  computed: {
    ...mapState({
      // infoData(state) {
      //   return state.common['loan/paraminfo'].data
      // }
    }),
  },
  methods: {
    ...mapActions(['fetchCommon']),
    checkWelidai() {
      this.showWlid = true
      this.form.welidai_name = this.showWlid ? '' : this.form.welidai_name
    },
    keyupWelidai() {
      if(this.form.welidai_name) {
        this.showWlid = false
      }
    },
    onFinish({ value, selectedOptions }) {
      // console.log(value,selectedOptions)
      this.form.city_name = value
      this.form.provcity = selectedOptions.map((option) => option.text).join(',');
      this.showCity = false;
    },
    onChange({ value, selectedOptions }) {
      setTimeout(() => {
        this.fetchCommon({
          request: 'webapi/areainfo',
          path: 'webapi/areainfo',
          data: {
            prov_id: selectedOptions[0].prov_id
          },
          onSuccess: (res) => {
            this.carareaOption[selectedOptions[0].index].children = res.data.map(a=>{
              a.text = a.city_name
              a.value = a.city_name
              return a
            })
          },
          onFail: (err) => {
            this.$toast(err.msg)
          }
        })
      }, 500);
    },
    checksrxsRadio(value) {
      this.form.incomefrom_name = value
    },
    checkxyjlRadio(value) {
      this.form.creditrecord_name = value
    },
    onSubmit() {
      // console.log(this.form)
      if(this.form.realname === '' && this.infoData.result.realname) {
        this.$toast('请输入真实姓名')
      }else
      if(this.form.idcard === '' && this.infoData.result.idcard) {
        this.$toast('请输入身份证号')
      }else
      if(!this.idcarExp.test(this.form.idcard) && this.infoData.result.idcard) {
        this.$toast('请输入正确的身份证号')
      }else
      if(this.form.city_name === '' && this.infoData.result.city_name) {
        this.$toast('请选择工作城市')
      }else
      if(this.form.income_name === '' && this.infoData.result.income_name) {
        this.$toast('请输入月收入')
      }else
      if(this.form.incomefrom_name === '' && this.infoData.result.incomefrom_name) {
        this.$toast('请选择收入形式')
      }else
      if(this.form.creditrecord_name === '' && this.infoData.result.creditrecord_name) {
        this.$toast('请选择信用记录')
      }else
      if(!this.showWlid && this.form.welidai_name === '' && this.infoData.result.welidai_name) {
        this.$toast('请输入微粒贷或选择无微粒贷')
      }else {
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
          loadingType: 'spinner',
        });
        const baseInfoData = JSON.stringify(this.form)
        window.localStorage.setItem('baseInfoData', baseInfoData)
        // console.log(baseInfoData)
        const loanNumber = this.loanNumber + 1
        this.$router.push('/loan/components/loanyx?channel_lable='+ this.channel_lable+'&loanNumber='+ loanNumber)
      }
    },
    validator(val) {
      return this.idcarExp.test(val)
    }
  },
  components: {
    [Cell.name]: Cell,
    [Radio.name]: Radio,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Button.name]: Button,
    [Field.name]: Field,
    [Cascader.name]: Cascader,
    [Popup.name]: Popup,
    [Stepper.name]: Stepper,
    [Form.name]: Form 
  }
}
</script>